module.exports = __webpack_public_path__ + "img/chofu_halfticket_on.06641dbd.svg";